// File Metadata:
// Filename: CompetencyList.js
// Version: 1.00
// Created: 2025-03-28 19:47:11
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import {
    Paper, Typography, Box, Grid,
    Card, CardContent, Chip,
    LinearProgress
} from '@mui/material'
import { Engineering, School } from '@mui/icons-material'

const CompetencyList = ({ competencies = [], userId }) => {
    return (
        <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
                Competencies & Certifications
            </Typography>

            <Grid container spacing={2}>
                {competencies.map((comp, index) => (
                    <Grid item xs={12} md={4} key={index}>
                        <Card variant="outlined">
                            <CardContent>
                                <Box display="flex" justifyContent="space-between" mb={1}>
                                    <Typography variant="subtitle1">
                                        {comp.skill}
                                    </Typography>
                                    <Chip 
                                        size="small"
                                        label={comp.level}
                                        icon={<School />}
                                    />
                                </Box>

                                {comp.expiryDate && (
                                    <Box>
                                        <Typography variant="caption" color="textSecondary">
                                            Expires: {new Date(comp.expiryDate).toLocaleDateString()}
                                        </Typography>
                                        <LinearProgress 
                                            variant="determinate"
                                            value={calculateProgress(comp.expiryDate)}
                                        />
                                    </Box>
                                )}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    )
}

const calculateProgress = (expiryDate) => {
    // Add progress calculation logic
    return 75
}

export default CompetencyList
